import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ModeloDeAtendimento } from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-balanced-unbalanced-toggle',
  templateUrl: './balanced-unbalanced-toggle.component.html',
  styleUrls: ['./balanced-unbalanced-toggle.component.scss']
})
export class BalancedUnbalancedToggleComponent implements OnInit {

  @Input()
  value: ModeloDeAtendimento;

  @Output()
  valueChange = new EventEmitter<ModeloDeAtendimento>();

  constructor() { }

  ngOnInit(): void {
  }

  optionSelected(event: MatButtonToggleChange): void {
    this.valueChange.next(event.value);
  }

}
